import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { Button, Modal, Divider, Input, Space, message } from 'antd';
import { getToolAccessLevels, getToolCategories } from '../../graphql/tooling';
import addToTooling from './graphql';

import { masterLookupForItem } from '../../graphql/item';
// import requestOrganizationById from '../../pages/ToolingManagement/graphql';
import { isNationalItemIdentificationNumber } from '../../utils/validationUtils';

export default function AddToolingHOC(AddToolPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        email: PropTypes.string.isRequired,
        cageCode: PropTypes.string.isRequired,
      }).isRequired,
      onReturnToMainPage: PropTypes.func.isRequired,
    };

    static initialState = {
      formValues: {
        accessLevel: {
          selectValueA: '',
          displayValues: [],
        },
        category: {
          selectValueC: '',
          displayValues: [],
        },

        partNum: '',
        niin: '',
        description: '',
        comments: '',

        masterToolingId: '',

      },
      isLoading: true,
      errors: [],
      alertType: '',
      alertMessage: '',
      modalOpen: true,


    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      // const { auth } = this.props;
      // const orgDetails = await getCageCode(auth.organizationId);

      const accessLevelOptions = this._createOptions(await this._optionsAccessLevelData());
      const categoryOptions = this._createOptions(await this._optionsCategoryData());

      // this.setState({
      //   cage: orgDetails.organization.cageCode,
      // });

      // CATHARINA TODO use old state
      const formValues = { ...this.state.formValues };
      formValues.accessLevel.selectValueA = '1';
      formValues.accessLevel.displayValues = accessLevelOptions;
      formValues.category.selectValueC = '0';
      formValues.category.displayValues = categoryOptions;

      this.setState({ formValues });
    }

    _createOptions = obj => {
      const keys = Object.keys(obj);
      const options = keys.map(key => ({ text: obj[key], value: key }));
      return options;
    };

    _optionsAccessLevelData = async () => {
      let res = '';
      res = await getToolAccessLevels();
      return res;
    };

    _optionsCategoryData = async () => {
      let res = '';
      res = await getToolCategories();
      return res;
    };

    _handleInitalValueReset = () => {
      // CATHARINA TODO use old state
      const formValues = { ...this.state.formValues };

      formValues.accessLevel.selectValueA = '1';
      formValues.category.selectValueC = '0';

      this.setState({ formValues });
    };

    _hideMessage = () => this.setState({ alertMessage: '', alertType: '' });

    _onSubmit = async event => {
      // const formValues = { ...this.state.formValues };
      const { auth } = this.props;

      const {
        niin,
        ownerCage,
        description = '',
        partNum = '',
        comments = '',
        cage = auth.cageCode,
        designAlloy = '',
        toolingRef = '',
        accessLevel,
        category,
      } = event;


      // const accLvl = { [formValues.accessLevel.selectValueA]: '' }
      // const cat = { [formValues.category.selectValueC]: '' }
      // const accKey = [Object.keys(accLvl)[0]].toString();
      // const catKey = [Object.keys(cat)[0]].toString();

      const obj = {
        partNum: `${partNum}`,
        niin: `${niin}`,
        description: `${description}`,
        toolingRef: `${toolingRef}`,
        ownerCage: `${ownerCage === undefined ? '' : ownerCage}`,
        ownerName: '',  // not used from front end addTooling form so empty is passed to the service and goes to db2
        designAlloy: `${designAlloy}`,
        comments: `${comments}`,
        accessLevel: `${accessLevel.selectValueA}`,
        category: `${category.selectValueC}`,
        cage: `${cage}`,
        modifiedBy: `${auth.email}`,
      }
      try {
        const { addTooling } = await addToTooling({
          ...obj,
        });

        if (addTooling.status === 'success') {
          message.info("Tooling record added to database.");
          // NFFS-442
          setTimeout(() => this.props.onReturnToMainPage(), 1000);
        } else {
          message.error("Failed to add Tooling record to database. Record may already exists.");
        }
      } catch (error) {
        message.error("Failed to add Tooling record to database. You may not have the permissions.");
      }
    };

    enableAddToolingBtn = () => {
      if (document.getElementById("btnAddTooling")) {
        document.getElementById("btnAddTooling").disabled = false;
        document.getElementById("btnAddTooling").className = "nf-button nf-button--form nf-button--orange btn btn-secondary";
      }
    };

    handleOkToolingLookup = async () => {

      if (this.state.formValues.partNum) {
        if (!!this.state.formValues.niin && isNationalItemIdentificationNumber(this.state.formValues.niin)) {
          message.error('Part NIIN should contain nine digits and no other characters!', 6);
          return;
        }

        const obj = {
          cage: this.props.auth.cageCode,
          partNum: this.state.formValues.partNum,
          niin: this.state.formValues.niin,
          searchType: "T"
        }

        try {
          const { masterLookupItem } = await masterLookupForItem({
            ...obj,
          });

          console.log('lookup item master in DB2 => ', masterLookupItem);
          if (masterLookupItem.isToolingExist) {
            message.error('Tool already exist in database! Nothing to do.', 6);
          } else if (masterLookupItem.toolingManagementData.masterTblRecInserted === true) {
            message.info('Please finish adding tooling by using the Add Tooling form below.', 10);
            this.closeModal();
            this.enableAddToolingBtn();
          } else {
            message.info('Found master record and data is shown.', 6);
            this.closeModal();
            this.enableAddToolingBtn();
            if (document.getElementById('description')) {
              document.getElementById('description').setAttribute('disabled', true);
            }
          }

          if (masterLookupItem.toolingManagementData) {
            const formValues = { ...this.state.formValues };
            formValues.description = masterLookupItem.toolingManagementData.description;
            formValues.comments = masterLookupItem.toolingManagementData.comments;
            formValues.masterToolingId = masterLookupItem.toolingManagementData.id;
            this.setState({ formValues });
          }
        } catch (error) {
          message.error('Part Number and NSN lookup failed.', 6);
        }
      } else {
        message.error('Part Number is a required field! Please enter Part Number!', 6);
      }
    };

    onChange = e => {
      const value = e.target.value;
      const name = e.target.name;

      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          [name]: value,
        }
      }))
    };

    openToolingModal = () => {
      this.setState({
        modalOpen: true
      });
    };

    closeModal = () => {
      this.setState({
        modalOpen: false
      });
    };

    render() {
      const { onReturnToMainPage } = this.props;
      const {
        formValues,
        alertType,
        alertMessage,
        modalOpen,
      } = this.state;

      // Configure Page
      const pageProps = {
        onSubmit: this._onSubmit,
        formValues,
        alertType,
        alertMessage,
        hideMessage: this._hideMessage,
        handleInitalValueReset: this._handleInitalValueReset,
        onReturnToMainPage,
      };

      return (
        <Container style={{ width: '85vw', maxWidth: 'none' }}>
          <AddToolPage {...pageProps}
          />

          <Modal
            title="Add Tooling Record"
            visible={modalOpen}
            onOk={this.handleOkToolingLookup}
            onCancel={onReturnToMainPage}

            footer={[
              <Button key="back" className="nf-button nf-button--gray-border btn btn-secondary"
                onClick={onReturnToMainPage}>
                Cancel
              </Button>,
              <Button className="nf-button nf-button--form nf-button--orange btn btn-secondary"
                key="submit"
                type="primary"
                // disabled={!newRfq && !selectedRfq}
                onClick={this.handleOkToolingLookup}
              >
                Submit
              </Button>,
            ]}
          >
            <Space direction="vertical" >
              <Input name='partNum' id='partNum' addonBefore="Part Number *" placeholder="Add part number (Required)" value={this.state.formValues.partNum} onChange={this.onChange} />
              <Input name='niin' id='niin' addonBefore="NIIN" placeholder="Add NIIN (Optional)" value={this.state.formValues.niin} onChange={this.onChange} />
            </Space>
            <Divider plain />
          </Modal>
        </Container>

      );
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/AddTooling/AddToolingHOC.jsx